/** 复合绘制：楼层队列（左）+ 井道动画（右），每帧由 SimSession.onFrame 调用。 */
import { renderShafts, type RenderCar } from './shaft-renderer';
import { renderFloorPanel } from './floor-panel-renderer';
import { interpolatedFloor } from './interpolation';
import { THEME } from './theme';
import type { SimulationSnapshot } from '../core/snapshot';
import type { KinematicsParams } from '../core/physics/kinematics';

export interface DrawOpts {
  width: number;
  height: number;
  floors: number;
  kin: KinematicsParams;
  waitWarnMs?: number;
}

export function drawSimulation(
  ctx: CanvasRenderingContext2D,
  snapshot: SimulationSnapshot,
  visualSimMs: number,
  opts: DrawOpts,
): void {
  const { width, height, floors, kin, waitWarnMs } = opts;
  ctx.fillStyle = THEME.bg;
  ctx.fillRect(0, 0, width, height);

  const panelW = Math.min(104, width * 0.12);
  renderFloorPanel(ctx, snapshot.floors, { x: 0, y: 0, width: panelW, height, waitWarnMs });

  const cars: RenderCar[] = snapshot.cars.map((c) => ({
    id: c.id,
    floor: interpolatedFloor(c, visualSimMs, kin),
    direction: c.direction === 1 ? 1 : c.direction === -1 ? -1 : 0,
    load: c.load,
    capacity: c.capacity,
    doorOpen: c.state === 'doorOpen',
  }));

  ctx.save();
  ctx.translate(panelW, 0);
  renderShafts(ctx, { cars }, { width: width - panelW, height, floors });
  ctx.restore();
}
